import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cifResponseData: null,
};

const userSliceBid = createSlice({
  name: "userSliceDetails",
  initialState,
  reducers: {
    setCifResponseData: (state, action) => {
      state.cifResponseData = action.payload;
    },
  },
});
export const { setCifResponseData } = userSliceBid.actions;
export default userSliceBid.reducer;
